module.exports = __webpack_public_path__ + "static/media/back.0e3ae76b.svg";